import React, { useEffect, useState } from 'react';

//Components
import { GIButton } from 'app-components';
import { FormattedMessage } from 'react-intl';
import Dropdown from '../../../lib/inputs/Dropdown';

const TemplateListHeader = props => {
    const { openModal, cannedCategory, handleSelection, handleActiveEnable } = props;
    const [selectedItem, setSelectedItem] = useState('Send Message');
    const [isChecked, setChecked] = useState(true);
    const [category, setCategory] = useState([{}]);
    const options: any = [];
    useEffect(() => {
        cannedCategory?.data?.map(item => {
            options.push({ value: item.templateCategoryId, text: item.categoryName });
        });
        setCategory(options);
    }, [cannedCategory]);

    const addNewTemplate = () => {
        openModal();
    };

    const handleSelect = eventKey => {
        handleSelection(eventKey);
        setSelectedItem(eventKey);
    };

    const handleChange = event => {
        handleActiveEnable(event.target.checked);
        setChecked(event.target.checked);
    };

    return (
        <div className="grid-row margin-bottom-105" id="templateList">
            <div className="desktop:grid-col-5">
                <div className="style-center-div">
                    <label>
                        <FormattedMessage id="ticket_management.category" />
                    </label>

                    <div className="template-drop-down">
                        <Dropdown
                            dataTestId="canned_response_template_category_drop_down"
                            label={{ selectedItem }}
                            inputData={{
                                id:'canned_response_category_dropdown',
                                inputClass: [''],
                                options: category,
                                value: selectedItem,
                            }}
                            inputActions={{
                                handleFieldChange: e => handleSelect(e),
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="grid-col-fill margin-left-1">
                <div className="style-center-div">
                    <FormattedMessage id="ticket_management.templateShowActiveTemplate" />
                    <label className="switch margin-left-1em">
                        <input type="checkbox" data-testid="canned_response_show_active_template" className="margin-left-1em" checked={isChecked} onChange={handleChange} />
                        <span className="slider"></span>
                    </label>   
                </div>
            </div>
            <div className="desktop:grid-col-3 text-right">
                <GIButton
                    id="createNewTemplateButton"
                    dataTestId="canned_response_create_new_template_button"
                    labelId="button.create_new_template"
                    onClickHandler={addNewTemplate}
                />
            </div>
        </div>
    );
};
export default TemplateListHeader;
